// filepath: src/components/DiffViewer.js
import React, {useMemo} from 'react';
import ReactDiffViewer from 'react-diff-viewer-continued';

function prettyText(value) {
  if (value == null) return '';
  if (typeof value === 'string') {
    const t = value.trim();
    if ((t.startsWith('{') && t.endsWith('}')) || (t.startsWith('[') && t.endsWith(']'))) {
      try { return JSON.stringify(JSON.parse(t), null, 2); } catch { return value; }
    }
    return value;
  }
  try { return JSON.stringify(value, null, 2); } catch { return String(value); }
}

const DiffViewer = ({ left, right, style, leftLabel, rightLabel }) => {
  const { leftText, rightText } = useMemo(() => ({
    leftText: prettyText(left),
    rightText: prettyText(right),
  }), [left, right]);

  const noContent = (!leftText || leftText.trim() === '') && (!rightText || rightText.trim() === '');
  if (noContent) {
    return <div style={{ fontStyle: 'italic', color: '#999' }}>비교할 내용이 없습니다.</div>;
  }

  return (
    <div style={style}>
      <ReactDiffViewer
        oldValue={leftText}
        newValue={rightText}
        splitView
        hideLineNumbers={false}
        showDiffOnly={false}
        leftTitle={leftLabel || ''}
        rightTitle={rightLabel || ''}
      />
    </div>
  );
};

export default DiffViewer;
